"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1230],{

/***/ 75652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27060);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5616);
/* harmony import */ var _care_material_ui_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5136);
/* harmony import */ var react_player__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22004);
/* harmony import */ var react_player__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_player__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);






var ModalVideo = function ModalVideo(_ref) {
  var isVisible = _ref.isVisible,
      title = _ref.title,
      videoUrl = _ref.videoUrl,
      height = _ref.height,
      onClose = _ref.onClose,
      dataTestId = _ref.dataTestId;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    variant: "dynamic",
    onClose: onClose,
    open: isVisible,
    title: title,
    sx: {
      '.MuiPaper-root': {
        width: '600px'
      }
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
      sx: {
        borderRadius: 0,
        [_care_material_ui_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.breakpoints.down */ .rS.breakpoints.down('md')]: {
          minWidth: 0
        }
      },
      "data-testid": dataTestId,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_player__WEBPACK_IMPORTED_MODULE_4___default()), {
        url: videoUrl,
        controls: true,
        playing: true,
        height: height !== null && height !== void 0 ? height : 306,
        width: "100%",
        style: {
          backgroundColor: _care_material_ui_theme__WEBPACK_IMPORTED_MODULE_3__/* .theme.palette.common.black */ .rS.palette.common.black
        }
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ModalVideo);

/***/ }),

/***/ 20935:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "lr": function() { return /* reexport */ ui_Carousel; },
  "$X": function() { return /* reexport */ ui_IconTile; },
  "UP": function() { return /* reexport */ ui_InputField; },
  "TK": function() { return /* reexport */ ui_LoadingSpinner; },
  "e3": function() { return /* reexport */ ui_PlayButtonLink; },
  "EI": function() { return /* reexport */ ui_SegmentControl; },
  "jL": function() { return /* reexport */ ui_SelectBox; }
});

// UNUSED EXPORTS: LabeledImage

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ui/LabeledImage.tsx

var _excluded = (/* unused pure expression or super */ null && (["alt", "containerClassName", "label", "labelClassName", "loading", "src"]));





var LabeledImage = function LabeledImage(_ref) {
  var alt = _ref.alt,
      containerClassName = _ref.containerClassName,
      label = _ref.label,
      labelClassName = _ref.labelClassName,
      loading = _ref.loading,
      src = _ref.src,
      restProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(Box, {
    className: containerClassName,
    textAlign: "center",
    children: [/*#__PURE__*/_jsx(Box, {
      sx: {
        marginLeft: 'auto',
        marginRight: 'auto'
      },
      children: /*#__PURE__*/_jsx(Image, {
        alt: alt,
        "aria-label": restProps['aria-label'],
        height: "100%",
        loading: loading,
        src: src,
        width: "100%"
      })
    }), /*#__PURE__*/_jsx(Box, {
      lineHeight: 1.428571,
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "body3",
        children: label
      })
    })]
  });
};

/* harmony default export */ var ui_LabeledImage = ((/* unused pure expression or super */ null && (LabeledImage)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box_Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(10615);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.min.css
var carousel_min = __webpack_require__(16703);
;// CONCATENATED MODULE: ./src/components/ui/Carousel.tsx


var Carousel_excluded = ["containerClassName", "children", "interval", "renderArrowNext", "renderArrowPrev", "shouldAutoPlay", "shouldShowArrows", "width"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Carousel = function Carousel(_ref) {
  var containerClassName = _ref.containerClassName,
      children = _ref.children,
      _ref$interval = _ref.interval,
      interval = _ref$interval === void 0 ? 4000 : _ref$interval,
      renderArrowNext = _ref.renderArrowNext,
      renderArrowPrev = _ref.renderArrowPrev,
      shouldAutoPlay = _ref.shouldAutoPlay,
      _ref$shouldShowArrows = _ref.shouldShowArrows,
      shouldShowArrows = _ref$shouldShowArrows === void 0 ? false : _ref$shouldShowArrows,
      width = _ref.width,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref, Carousel_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
    className: containerClassName,
    "data-testid": "carousel",
    sx: {
      '& .carousel-root': {
        height: '100%'
      },
      '& .carousel-slider': {
        height: '100%'
      },
      height: '100%',
      position: 'relative'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(js/* Carousel */.lr, _objectSpread(_objectSpread({
      preventMovementUntilSwipeScrollTolerance: true,
      swipeScrollTolerance: 50,
      autoPlay: shouldAutoPlay,
      dynamicHeight: false,
      emulateTouch: true,
      infiniteLoop: true,
      interval: interval,
      renderArrowNext: renderArrowNext,
      renderArrowPrev: renderArrowPrev,
      showArrows: shouldShowArrows,
      showStatus: false,
      showThumbs: false,
      stopOnHover: true,
      swipeable: true,
      width: width,
      renderIndicator: function renderIndicator(onClickHandler, isSelected, index, label) {
        if (isSelected) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
            component: "li",
            sx: {
              background: '#444',
              width: 10,
              height: 10,
              display: 'inline-block',
              margin: '0 8px',
              borderRadius: 10,
              cursor: 'pointer'
            },
            "aria-label": "Selected: ".concat(label, " ").concat(index + 1),
            title: "Selected: ".concat(label, " ").concat(index + 1),
            role: "option",
            "aria-selected": "true"
          });
        }

        return /*#__PURE__*/(0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
          component: "li",
          sx: {
            background: '#ddd',
            width: 10,
            height: 10,
            display: 'inline-block',
            margin: '0 8px',
            borderRadius: 10,
            cursor: 'pointer'
          },
          onClick: onClickHandler,
          onKeyDown: onClickHandler,
          value: index,
          role: "option",
          "aria-selected": "false",
          tabIndex: 0,
          title: "".concat(label, " ").concat(index + 1),
          "aria-label": "".concat(label, " ").concat(index + 1)
        }, index);
      }
    }, restProps), {}, {
      children: children
    }))
  });
};

/* harmony default export */ var ui_Carousel = (Carousel);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@care/material-ui-theme/dist/config/theme/theme.js + 68 modules
var theme = __webpack_require__(5136);
;// CONCATENATED MODULE: ./src/assets/images/play-button.png
/* harmony default export */ var play_button = ({"src":"/app/hp-vhp/_next/static/media/play-button.7dbddd90.png","height":36,"width":36,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAgVBMVEXj5eni5ejg4+bf4ua9wsn////19vj09vjm6ezk5+vj5uri5enn6u3m6ezl6Ovk5+qhp7Cgpq+hp7CgprB4gY91f41HWHBEVm4ALFYAJVMAACzt7/Hr7O7d3uHc3uBoc4RmcYNjb4FgbH9dan1baHxUY3hSYXYAAEEAAEAAADIAADH5rIA+AAAAG3RSTlMAAAAAAw46OlJSUlJTU1NT5eXm5vv7+/v7+/td3nBtAAAAR0lEQVR42gVABRKAIBBchANbwsTu+P8DHQhGaUxcIJDu3LRiIPOU7WcJyeLHvt4zFLOfhuaIQO6uulcTIM21WsUhOIU5MfEDlkEELH74xQMAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/ui/PlayButtonLink.tsx


var PlayButtonLink_excluded = ["children"];

function PlayButtonLink_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PlayButtonLink_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PlayButtonLink_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PlayButtonLink_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var PlayButtonLink = function PlayButtonLink(_ref) {
  var _theme$palette$care;

  var children = _ref.children,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref, PlayButtonLink_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Link/* default */.Z, PlayButtonLink_objectSpread(PlayButtonLink_objectSpread({
    sx: {
      color: (_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.black,
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: 'bold',
      marginTop: '24px',
      display: 'flex',
      [theme/* theme.breakpoints.down */.rS.breakpoints.down('md')]: {
        justifyContent: 'center'
      }
    },
    underline: "none"
  }, restProps), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
      sx: {
        position: 'relative',
        left: '-4px !important',
        top: '-4px !important'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        height: 36,
        width: 36,
        src: play_button
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
      component: "span",
      sx: {
        marginTop: '2px !important'
      },
      children: children
    })]
  }));
};

/* harmony default export */ var ui_PlayButtonLink = (PlayButtonLink);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Card/Card.js
var Card = __webpack_require__(37088);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography_Typography = __webpack_require__(15861);
;// CONCATENATED MODULE: ./src/components/ui/IconTile.tsx







var IconTile = function IconTile(_ref) {
  var _theme$palette$care;

  var className = _ref.className,
      iconSrc = _ref.iconSrc,
      label = _ref.label;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Card/* default */.Z, {
    careVariant: "subtle",
    sx: {
      background: (_theme$palette$care = theme/* theme.palette.care */.rS.palette.care) === null || _theme$palette$care === void 0 ? void 0 : _theme$palette$care.white,
      borderRadius: '16px',
      boxShadow: '0px 0px 16px rgba(0,0,0,.25)',
      display: 'inline-block',
      height: '160px',
      margin: '0 20px',
      textAlign: 'center',
      width: '160px'
    },
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
      sx: {
        padding: 0,
        marginTop: theme/* theme.spacing */.rS.spacing(2)
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        sx: {
          [theme/* theme.breakpoints.up */.rS.breakpoints.up('sm')]: {
            margin: '3px 40px 8px 40px'
          }
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          alt: "Icon Tile",
          height: 80,
          layout: "intrinsic",
          loading: "lazy",
          src: iconSrc,
          width: 80
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Typography_Typography/* default */.Z, {
          children: label
        })
      })]
    })
  });
};

/* harmony default export */ var ui_IconTile = (IconTile);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/TextField/TextField.js
var TextField = __webpack_require__(53340);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/ui/InputField.tsx


var InputField_excluded = ["onChange", "prefix"];

function InputField_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InputField_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InputField_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InputField_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var InputField = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var onChange = _ref.onChange,
      prefix = _ref.prefix,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref, InputField_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(TextField/* default */.Z, InputField_objectSpread({
    InputProps: {
      startAdornment: prefix && /*#__PURE__*/(0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
        sx: {
          marginLeft: '8px'
        },
        position: "start",
        children: prefix
      })
    },
    inputRef: ref,
    onChange: onChange
  }, restProps));
});
/* harmony default export */ var ui_InputField = (InputField);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js + 3 modules
var InputLabel = __webpack_require__(33841);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 11 modules
var Select = __webpack_require__(71683);
;// CONCATENATED MODULE: ./src/components/ui/SelectBox.tsx


var SelectBox_excluded = ["fullWidth", "label", "options"];

function SelectBox_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SelectBox_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SelectBox_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SelectBox_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SelectBox = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var fullWidth = _ref.fullWidth,
      label = _ref.label,
      options = _ref.options,
      restProps = (0,objectWithoutProperties/* default */.Z)(_ref, SelectBox_excluded);

  var renderOptions = function renderOptions(item) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
      value: item.value,
      children: item.label
    }, item.value);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
    sx: {
      '& .MuiInput-root': {
        borderRadius: '3px'
      },
      width: '100%'
    },
    fullWidth: fullWidth,
    variant: "standard",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
      id: "select-box-label-".concat(label),
      htmlFor: restProps.id,
      children: label
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* default */.Z, SelectBox_objectSpread(SelectBox_objectSpread({}, restProps), {}, {
      inputRef: ref,
      labelId: "select-box-label-".concat(label),
      native: true,
      children: options.map(renderOptions)
    }))]
  });
});
/* harmony default export */ var ui_SelectBox = (SelectBox);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Loader/Loader.js
var Loader = __webpack_require__(4806);
;// CONCATENATED MODULE: ./src/components/ui/LoadingSpinner.tsx


function LoadingSpinner_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function LoadingSpinner_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? LoadingSpinner_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : LoadingSpinner_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var LoadingSpinner = function LoadingSpinner(props) {
  var inline = props.inline,
      testId = props.testId;

  if (inline) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Box_Box/* default */.Z, {
      "data-testid": testId !== null && testId !== void 0 ? testId : 'loading-spinner',
      my: "20px",
      textAlign: "center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {
        sx: {
          display: 'inline-block'
        }
      })
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Box_Box/* default */.Z, LoadingSpinner_objectSpread(LoadingSpinner_objectSpread({
    alignItems: "center",
    "data-testid": testId !== null && testId !== void 0 ? testId : 'loading-spinner',
    display: "flex",
    height: "100vh",
    justifyContent: "center"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Loader/* default */.Z, {})
  }));
};

/* harmony default export */ var ui_LoadingSpinner = (LoadingSpinner);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/SegmentControl/SegmentControl.js
var SegmentControl_SegmentControl = __webpack_require__(46774);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
;// CONCATENATED MODULE: ./src/components/ui/SegmentControl.tsx


function SegmentControl_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SegmentControl_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SegmentControl_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SegmentControl_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var SegmentControl = function SegmentControl(props) {
  var theme = (0,useTheme/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
    container: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SegmentControl_SegmentControl/* default */.Z, SegmentControl_objectSpread({
        sx: {
          fontFamily: theme.typography.fontFamily,
          border: "".concat(theme.spacing(1), " solid ").concat(theme.palette.grey[100]),
          borderRadius: theme.spacing(7),
          '& > span': {
            padding: theme.spacing(1),
            borderRadius: theme.spacing(5),
            [theme.breakpoints.down('sm')]: {
              fontSize: '15px !important'
            }
          },
          '& #segment-indicator': {
            padding: theme.spacing(1),
            borderRadius: theme.spacing(5)
          }
        }
      }, props))
    })
  });
};

/* harmony default export */ var ui_SegmentControl = (SegmentControl);
;// CONCATENATED MODULE: ./src/components/ui/index.ts










/***/ }),

/***/ 55252:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ getPartnersRXCookie; },
/* harmony export */   "t": function() { return /* binding */ getStatesListOptions; }
/* harmony export */ });
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65885);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18459);


var getStatesListOptions = function getStatesListOptions() {
  return Object.keys(_constants__WEBPACK_IMPORTED_MODULE_0__/* .StateCodeMap */ .os).map(function (key) {
    return {
      label: key,
      value: _constants__WEBPACK_IMPORTED_MODULE_0__/* .StateCodeMap */ .os[key]
    };
  });
};
var getPartnersRXCookie = function getPartnersRXCookie() {
  var _cookies$get;

  var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z();
  return (_cookies$get = cookies.get(_constants__WEBPACK_IMPORTED_MODULE_0__/* .HOMEPAY_PARTNERS_RX_COOKIE */ .LC)) !== null && _cookies$get !== void 0 ? _cookies$get : '';
};

/***/ })

}]);